import { jsx as _jsx } from "react/jsx-runtime";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var ExternalLink = function (_a) {
    var _b = _a.color, color = _b === void 0 ? "#FFFFFF" : _b, props = __rest(_a, ["color"]);
    return (_jsx("svg", __assign({ width: "12px", height: "12px", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", fill: color }, props, { children: _jsx("g", __assign({ transform: "translate(-144.000000, -507.000000)" }, { children: _jsx("g", __assign({ transform: "translate(144.000000, 507.000000)" }, { children: _jsx("path", { d: "M1.77777778,0 C0.8061664,0 0,0.8061664 0,1.77777778 L0,14.2222222 C0,15.1938338 0.8061664,16 1.77777778,16 L14.2222222,16 C15.1938338,16 16,15.1938338 16,14.2222222 L16,8 L14.2222222,8 L14.2222222,14.2222222 L1.77777778,14.2222222 L1.77777778,1.77777778 L8,1.77777778 L8,0 L1.77777778,0 Z M9.77777778,0 L9.77777778,1.77777778 L12.9652782,1.77777778 L4.70486116,10.0381947 L5.96180551,11.2951387 L14.2222222,3.03472222 L14.2222222,6.22222222 L16,6.22222222 L16,0 L9.77777778,0 Z" }) })) })) })));
};
export default ExternalLink;
//# sourceMappingURL=externalLink.js.map